
import React from 'react';
import { Helmet } from 'react-helmet';

interface SEOMetaTagsProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: string;
  noindex?: boolean;
  keywords?: string;
  author?: string;
  twitterHandle?: string;
  publishedTime?: string;
  modifiedTime?: string;
}

export const SEOMetaTags: React.FC<SEOMetaTagsProps> = ({
  title,
  description,
  canonicalUrl,
  ogImage = 'https://chrona.app/og-image.jpg', // Default OG image
  ogType = 'website',
  noindex = false,
  keywords = 'Terminbuchung, Online-Termine, Friseur, Nagelstudio, Kosmetik, Wellness, CHRONA',
  author = 'CHRONA',
  twitterHandle = '@chronaapp',
  publishedTime,
  modifiedTime
}) => {
  const baseUrl = 'https://chrona.app'; // Your app's base URL
  const fullCanonicalUrl = canonicalUrl ? `${baseUrl}${canonicalUrl}` : baseUrl;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullCanonicalUrl} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      
      {/* Robots Meta Tag */}
      <meta 
        name="robots" 
        content={noindex ? 'noindex, nofollow' : 'index, follow'} 
      />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:image" content={ogImage.startsWith('http') ? ogImage : `${baseUrl}${ogImage}`} />
      <meta property="og:site_name" content="CHRONA" />
      
      {/* Article specific tags */}
      {ogType === 'article' && publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      {ogType === 'article' && modifiedTime && (
        <meta property="article:modified_time" content={modifiedTime} />
      )}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={twitterHandle} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage.startsWith('http') ? ogImage : `${baseUrl}${ogImage}`} />
      
      {/* Mobile optimization */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" />
      <meta name="theme-color" content="#212121" />
      
      {/* Language */}
      <meta property="og:locale" content="de_DE" />
      <meta httpEquiv="content-language" content="de-DE" />
    </Helmet>
  );
};
